<ng-template #buttons>
    <app-file-upload-button
        label="common.import"
        severity="secondary"
        [completedCallback]="store.api.importOrganization"
        (progress)="onImportProgress($event)"
    />
</ng-template>

<app-table
    tableKey="organizations"
    [showDelete]="store.isAllowed('organization.delete')()"
    [showButtonLabels]="true"
    [translatePrefix]="prefix"
    [columns]="columns"
    [buttons]="buttons"
    resource="organization"
    [gridData]="$any(store.data.getOrganizations())"
    [refreshCallback]="store.api.getOrganizations"
    (detailCallback)="goToDetail($event)"
    (createCallback)="goToCreate()"
    (deleteCallbackWithEvent)="delete($event)"
>
    <ng-template pTemplate="representativePerson" let-data="data">
        {{ data | formatPerson }}
    </ng-template>

    <ng-template pTemplate="contactPerson" let-data="data">
        {{ data | formatPerson }}
    </ng-template>

    <ng-template pTemplate="address" let-data="data">
        {{ data | formatAddress }}
    </ng-template>
</app-table>
